module.exports = __webpack_public_path__ + "img/zshead.1641520899224.png";